import axios from "axios";

const getAll = (documentId, callback) => {
    axios.request({
        url: `/api/checkpoints/document/${documentId}`,
        method: 'GET'
    }).then(response => callback(response.data))
}

const save = (values, callback) => {
    axios.request({
        url: values.id ? `/api/checkpoints/${values.id}` : '/api/checkpoints',
        method: values.id ? 'PUT' : 'POST',
        data: values
    }).then(response => callback(response.data))
}

const CheckpointActions = {
    getAll,
    save
}

export default CheckpointActions;